import React, { useEffect } from "react";
import { StyledH2, StyledTextInput } from "@aureskonnect/react-ui";
import { AvGroup, AvForm } from "availity-reactstrap-validation";
import { t } from "i18next";
import classnames from "classnames";
import { numberMatchWord } from "@constants/index";
import {
    store,
    setIsValidationPriceToTake,
    setIsValidationPriceTheSpot,
    setOrders,
} from "../../store";
import { useSnapshot } from "valtio";
import { ErrorMessage } from "./Orders";

const PriceInput = (props: {
    label: string;
    fieldKey: "numberToTake" | "numberOnTheSpot";
    validationKey: any;
    validationSetter: any;
    value: any;
    handlechange: any;
    className: string;
    hasMarginTop?: boolean;
}) => {
    return (
        <AvGroup className="d-flex justify-content-align mt-3 ml-3 px-5">
            <span
                className="mt-2 ml-5"
                style={{
                    font: "normal normal 400 16px/24px Segoe UI",
                    color: "#000000",
                    opacity: "1",
                    width: "329px",
                }}
            >
                {props.label}
            </span>
            <StyledTextInput
                min="0"
                onKeyPress={(event: any) => {
                    const inputValue = event.key;
                    if (!/[0-9]/.test(inputValue)) {
                        event.preventDefault();
                    }
                }}
                id={props.fieldKey}
                name={props.fieldKey}
                type="number"
                onChange={(e: any) =>
                    props.handlechange(
                        props.fieldKey,
                        e.target.value,
                        props.validationSetter
                    )
                }
                value={props.value.toString()}
                className={classnames(props.className, {
                    input__clz: props.validationKey,
                })}
                style={{
                    width: "110px",
                    marginTop: props.hasMarginTop ? "5px" : "0px",
                    height: "40px",
                }}
            />
            {props.validationKey && (
                <ErrorMessage
                    message={t("Please insert a price")}
                    fontSize="80"
                />
            )}
        </AvGroup>
    );
};

function OrdersMinimalPrice({ selectedRows }: any) {
    const { isValidationPriceTheSpot, isValidationPriceToTake } = useSnapshot(
        store
    );

    const getInitialOrderSettings = () => {
        let numberToTake = 0;
        let numberOnTheSpot = 0;

        if (selectedRows?.length && selectedRows[0]?.["minimum price"]) {
            const dataPrice = JSON.parse(selectedRows[0]["minimum price"]);
            numberToTake = dataPrice?.ST_MinCmd?.MinEmporter || 0;
            numberOnTheSpot = dataPrice?.ST_MinCmd?.MinSurplace || 0;
        }

        return { numberToTake, numberOnTheSpot };
    };

    const [orderSettings, setOrderSettings] = React.useState(
        getInitialOrderSettings
    );

    const updateDataPriceInStore = (settings: typeof orderSettings) => {
        const currentDataPrice =
            selectedRows?.length && selectedRows[0]?.["minimum price"]
                ? JSON.parse(selectedRows[0]["minimum price"])
                : null;

        const updatedDataPrice = currentDataPrice
            ? {
                  ...currentDataPrice,
                  ST_MinCmd: {
                      ...currentDataPrice.ST_MinCmd,
                      MinEmporter: settings.numberToTake,
                      MinSurplace: settings.numberOnTheSpot,
                  },
              }
            : {
                  ST_MinCmd: {
                      MinEmporter: settings.numberToTake,
                      MinSurplace: settings.numberOnTheSpot,
                  },
              };

        setOrders({
            numberToTake: settings.numberToTake,
            numberOnTheSpot: settings.numberOnTheSpot,
            dataPrice: updatedDataPrice,
        });
    };

    useEffect(() => {
        updateDataPriceInStore(orderSettings);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const updateOrderSetting = (
        field: keyof typeof orderSettings,
        value: number
    ) => {
        const newSettings = {
            ...orderSettings,
            [field]: value,
        };
        setOrderSettings(newSettings);
        updateDataPriceInStore(newSettings);
    };

    const handlePriceChange = (
        field: keyof typeof orderSettings,
        value: string,
        validationSetter: any
    ) => {
        if (value.match(numberMatchWord) || value === "0") {
            const numericValue = parseFloat(value);
            updateOrderSetting(field, numericValue);
            validationSetter(false);
        } else {
            validationSetter(true);
        }
    };

    return (
        <div>
            <div className="d-flex justify-content-between">
                <StyledH2
                    style={{
                        font: "normal normal 400 20px/27px Segoe UI",
                        color: "#000000",
                        opacity: "1",
                    }}
                    className="ml-5 pt-3"
                >
                    {t("Minimum price to place an order")}
                </StyledH2>
            </div>
            <AvForm>
                <PriceInput
                    label={t("To take")}
                    fieldKey={"numberToTake"}
                    validationKey={isValidationPriceToTake}
                    validationSetter={setIsValidationPriceToTake}
                    value={orderSettings.numberToTake}
                    handlechange={handlePriceChange}
                    className="cac_inp_minimumPriceTakAway"
                    hasMarginTop={true}
                />

                <PriceInput
                    label={t("On the spot")}
                    fieldKey={"numberOnTheSpot"}
                    validationKey={isValidationPriceTheSpot}
                    validationSetter={setIsValidationPriceTheSpot}
                    value={orderSettings.numberOnTheSpot}
                    handlechange={handlePriceChange}
                    className="cac_inp_minimumPriceOnTheSpot"
                    hasMarginTop={false}
                />
            </AvForm>
        </div>
    );
}

export default OrdersMinimalPrice;
